import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
	},
	actions: {
		async getPageInfo({
			commit
		},param) {
			let getPage = await PostApi.getPageInfo(param);
			getPage = getPage ? getPage.data : null;
			console.log('store pageInfo：', commit, param);
			return getPage;
		},
	},
	mutations: {
	},
}
